import ListViewV2 from "pages/App/DataListV2";
import React from "react";
import { create } from "zustand";
import DataListStore from "store/DataListStore";
import { Button, notification } from "antd";
import { getRequest } from "services/EndPointApiService";

const defaultDataStore = create(DataListStore);

export default function ReportBC() {
  const [loading, setLoading] = React.useState(false);

  return (
    <ListViewV2
      viewId={"reportbc"}
      store={defaultDataStore}
      extraToolbar={(rows) => {
        console.log("current rows", rows);
        return (
          <Button
            type="primary"
            loading={loading}
            onClick={async () => {
              setLoading(true);
              if (window.confirm(`Generate semua ongkos pengiriman ?`)) {
                const result = await getRequest("LionParcel/GenerateAllOngkir");
                if (result.length > 0) {
                  notification.success({
                    message: `Update Ongkir Berhasil`,
                    description: `Berhasil update ongkir untuk ${result.length} destinasi.`,
                  });
                }
              }
              setLoading(false);
            }}
          >
            Generate Ongkir
          </Button>
        );
      }}
    />
  );
}
